import { RemoteActivateInactivatePersonProfile } from 'data/usecases';
import { ActivateInactivatePersonProfileUseCaseInterface } from 'domain/usecases';
import { makeApiUrlPersonProfile } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteActivateInactivatePersonProfile =
  (): ActivateInactivatePersonProfileUseCaseInterface =>
    new RemoteActivateInactivatePersonProfile(
      makeApiUrlPersonProfile(),
      makeAxiosHttpClient(),
    );
